module.exports = __webpack_public_path__ + "img/product-shot_05_loading.e9feb26f.jpg";